import { render, staticRenderFns } from "./UserAdministrationPage.vue?vue&type=template&id=2e9c3208&scoped=true&"
import script from "./UserAdministrationPage.vue?vue&type=script&lang=js&"
export * from "./UserAdministrationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9c3208",
  null
  
)

export default component.exports